/** Setup keys belong only in the authenticator app, never in login requests. */
export function setupKeyInputError(value: string): string | null {
  const compact = value.replace(/\s/g, '');
  return /^[A-Z2-7]{32}$/i.test(compact) || /^otpauth:\/\//i.test(compact)
    ? 'This is a setup key. Add it to your authenticator app, then enter the 6-digit code the app generates.'
    : null;
}

export function twoFactorInputError(value: string, recovery = false): string | null {
  const setupError = setupKeyInputError(value);
  if (setupError) return setupError;
  if (recovery) {
    // Keep the original 5-5 recovery codes valid as well as current 4-4-4-4 codes.
    return /^(?:[A-F0-9]{5}-[A-F0-9]{5}|[A-F0-9]{4}(?:-[A-F0-9]{4}){3})$/i.test(value)
      ? null
      : 'Enter one of the recovery codes you saved when enabling two-factor authentication.';
  }
  return /^\d{6}$/.test(value) ? null : 'Enter the 6-digit code from your authenticator app.';
}
